import React, { useState }  from 'react';
import { useSelector }      from "react-redux";
import comment              from '../../../assets/images/comment_icon.png';
import trash                from '../../../assets/images/trash-2-32.png';
import { ApplicationState } from "../../../store";
import { APIState }         from '../../../store/API/types';
import {
  BookmarkState,
  BookmarkType
}                           from "../../../store/bookmarks/types";
import { SettingsState }    from "../../../store/settings/types";
import MyDate               from "../../../utils/MyDate";

import BookmarkThumbnailComponent from "../BookmarkThumbnailComponent";


interface Props {
  bookmarks: BookmarkType[],
  doSelect: (e: React.MouseEvent, id: number) => void,
  deleteBkm: (ids: number[]) => void,
}

const MsgIcon = (i: number, comments: string, id: number, onClick: (id: number) => void) =>
  comments
    ? <img src={comment}
           alt="Comments"
           width='20px'
           className={i % 2 === 0 ? 'darkcol pointer' : 'litecol pointer'}
           onClick={(e) => {
             e.preventDefault();
             e.stopPropagation();
             onClick(id)
           }}
    />
    : null
;

const DateTime = (time: number, className: string, i: number, isLocalTime: boolean) => (
  <div className={i % 2 === 0 ? className + ' darkcol' : className + ' litecol'}>
    {isLocalTime ? new MyDate(time).toLocaleString() : new MyDate(time).to24String()}
  </div>
);

const StringData = (text: string, className: string, i: number) => (
  <div className={i % 2 === 0 ? className + ' darkcol' : className + ' litecol'}>
    {text}
  </div>
);


const BookmarksContentComponent: React.FC<Props> = ({bookmarks, doSelect, deleteBkm}) => {
  const {selected} = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);
  const {isLocalTime} = useSelector<ApplicationState, SettingsState>(state => state.settings);
  const {privileges} = useSelector<ApplicationState, APIState>(state => state.API);
  const [openedComments, triggerComments] = useState<number[]>([]);
  const canDeleteBookmarks = privileges !== null && privileges.canDeleteBookmarks;

  const doTriggerComments = (id: number) => {
    const ind = openedComments.indexOf(id);
    ind > -1
      ? triggerComments([...openedComments.slice(0, ind), ...openedComments.slice(ind + 1)])
      : triggerComments([...openedComments, id])
  };

  return (
    <>
      {
        bookmarks.map((bkm: BookmarkType) => {
          let i = 1;
          return (
            <div key={bkm.id} id={`bkm-${bkm.id}`}>
              <div className={selected.includes(bkm.id) ? 'bookmarks__content notSelected' : 'bookmarks__content'}
                   onClick={(e) => doSelect(e, bkm.id)}
              >
                <div className='bookmarks-content__item reload'>{MsgIcon(i++, bkm.comment, bkm.id, doTriggerComments)}</div>
                {DateTime(bkm.occurred * 1000, 'bookmarks-content__item created', i++, isLocalTime)}
                {StringData(bkm.classification, 'bookmarks-content__item classification', i++)}
                {StringData(bkm.case, 'bookmarks-content__item case', i++)}
                {DateTime(bkm.start * 1000, 'bookmarks-content__item time', i++, isLocalTime)}
                {StringData((bkm.stop - bkm.start) + ' s', 'bookmarks-content__item duration', i++)}
                <div
                  className={i++ % 2 === 0 ? 'bookmarks-content__item label darkcol' : 'bookmarks-content__item label litecol'}>
                  {
                    bkm.files.map(({id}) => <div key={'label' + id}> {id} </div>)
                  }
                </div>
                <div
                  className={i++ % 2 === 0 ? 'bookmarks-content__item label status darkcol' : 'bookmarks-content__item status litecol'}>
                  {
                    bkm.files.map(({id, status}) => <div key={'status' + id}> {status} </div>)
                  }
                </div>
                <BookmarkThumbnailComponent files={bkm.files}
                                            i={i}
                                            timeBounds={{
                                              start: bkm.start * 1000,
                                              end: bkm.stop * 1000
                                            }}
                />
                {
                  (privileges !== null && canDeleteBookmarks) && <div
                    className={i++ % 2 === 0 ? 'bookmarks-content__item delete darkcol' : 'bookmarks-content__item delete litecol'}>
                    <img src={trash}
                         alt="delete"
                         width='20px'
                         onClick={(e) => {
                           e.stopPropagation();
                           deleteBkm([bkm.id])
                         }}
                    />
                  </div>
                }
              </div>
              <div className={'bookmarks__comments'}>
                {
                  (bkm.comment && openedComments.includes(bkm.id)) && <div>COMMENTS: {bkm.comment}</div>
                }
              </div>
            </div>
          )
        })
      }
    </>
  );
};

export default BookmarksContentComponent;